import {
  chakra,
  type ChakraProps,
  forwardRef,
  useModalStyles,
} from '@chakra-ui/react-v2';

export type ModalOverlineProps = ChakraProps;

export const ModalOverline = forwardRef<ModalOverlineProps, 'div'>(
  (props, ref) => {
    const { overline: overlineStyles } = useModalStyles();

    return <chakra.div ref={ref} __css={overlineStyles} {...props} />;
  },
);
ModalOverline.displayName = 'ModalOverline';
